

<div class="fixed inset-0 bg-black/60 bg-opacity-50 flex justify-center items-center z-[9999999999]">
    <div class="relative mx-auto w-[90%] sm:w-[460px] md:w-[484px] bg-white border border-gray-300 rounded-lg overflow-hidden flex flex-col max-h-[90vh] md:min-h-[360px] min-h-[420px] ">

    <div class="relative h-[120px] w-full overflow-hidden flex items-center justify-center px-4">
        <img [src]="environment.homeImageUrl + 'icon-wrapper1.svg'" alt="Top Image" class="object-cover w-full" />
        <button (click)="close()" class="cursor-pointer absolute right-4 top-4 text-gray-600 hover:text-gray-800 text-xl">
        &times;
        </button>
    </div>

    <div class="flex flex-col flex-grow justify-between">
        <div class="flex flex-col gap-3 px-4">
        <div class="flex justify-between items-center">
            <p class="font-bold text-lg text-[#344054]">{{ isBangla() ? 'সতর্কবার্তা' : 'Warning' }}</p>
            <button (click)="isBangla.set(!isBangla())"
                    class="text-sm text-blue-600 cursor-pointer hover:underline">
            {{ isBangla() ? 'View in English' : 'বাংলায় দেখুন' }}
            </button>
        </div>
        <p [ngClass]="isBangla() ? 'text-[13px] sm:text-base' : 'text-[13px] sm:text-base'"
            class="text-justify text-[#475467] leading-6">
            {{ isBangla() ?
            'এটি একটি বিদেশি চাকরির বিজ্ঞাপন। এই চাকরির বিবরণ ও নিয়োগ প্রক্রিয়ার সম্পূর্ণ দায়িত্ব সংশ্লিষ্ট নিয়োগকারী প্রতিষ্ঠানের। কোনো ভুল বা অসম্পূর্ণ তথ্যের জন্য বিডিজবস দায়ী নয়। চাকরিপ্রার্থীদের নিজ দায়িত্বে সতর্কতার সাথে আবেদন করার পরামর্শ দেওয়া হচ্ছে।' :
            'This is an overseas job advertisement. Individual organizations are responsible for the job descriptions or recruitment process published. Bdjobs.com is not liable for any incomplete or untrue information. Job seekers are advised to apply with caution.'
            }}
        </p>
        </div>
        <div class="px-4 pb-4 pt-2">
        <button (click)="close()"
                [ngClass]="isBangla() ? 'text-sm sm:text-base' : 'text-sm sm:text-base'"
                class="cursor-pointer w-full rounded-lg bg-[#C63C92] py-1.5 text-white hover:bg-[#a62e77] transition-colors">
            {{ isBangla() ? 'ঠিক আছে' : 'OK' }}
        </button>
        </div>
    </div>
    </div>
</div>
